"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Image = require("@ccw-pwa-ui/Image");
var _Dropdown = require("@ccw-pwa-ui/Dropdown");
var _Button = require("@ccw-pwa-ui/Button");
var _HeaderText = require("@ccw-pwa-ui/HeaderText");
require("./Header.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const CustomHeader = _ref => {
  let {
    imageUrl,
    imageStyle,
    languageData,
    filterData,
    leftImage,
    leftImageStyle,
    onLeftClick,
    onHeaderImgClick,
    rightImage,
    rightImageStyle,
    onRightClick,
    headerTitle,
    leftText,
    rightText,
    headerText,
    style,
    rightTextStyle,
    type,
    rightButtonText,
    rightButtonOnClick
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "ParentDiv",
    className: "d-flex  justify-content-between header-image-style",
    style: _objectSpread(_objectSpread({}, type !== "Desktop" ? {
      backgroundColor: '#ffffff'
    } : {}), style)
  }, type !== "Desktop" && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      display: 'flex'
    }
  }, leftImage && type !== "Desktop" && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "leftImage",
    className: "left-image",
    onClick: onLeftClick
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: leftImage,
    imageStyle: _objectSpread({
      padding: 10
    }, leftImageStyle)
  })), leftText && /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "leftText",
    className: "small-header-text d-flex align-items-center p-1"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    navigationUrl: 'https://www.google.com',
    headerStyle: {
      fontSize: 16,
      marginLeft: 10
    },
    variant: "link-text",
    headerText: leftText,
    onClick: onLeftClick
  }), " ")), /*#__PURE__*/_react.default.createElement("div", {
    style: _objectSpread({
      flex: 1,
      display: 'flex'
    }, type !== "Desktop" ? {
      justifyContent: 'center'
    } : {
      justifyContent: 'start'
    })
  }, headerTitle ? /*#__PURE__*/_react.default.createElement("div", {
    className: "small-header-text",
    "data-testid": "headerText"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: {
      fontSize: 16,
      marginRight: 130
    },
    variant: "link-text",
    headerText: headerText
  }), " ") : /*#__PURE__*/_react.default.createElement("div", {
    className: "center-image",
    "data-testid": "imageUrl",
    onClick: onHeaderImgClick
  }, " ", /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: imageUrl,
    imageStyle: _objectSpread({
      padding: 10
    }, imageStyle)
  }), " "), languageData && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      right: 210
    }
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, null)), filterData && /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'absolute',
      right: 20
    }
  }, /*#__PURE__*/_react.default.createElement(_Dropdown.Dropdown, null))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      justifyContent: 'end'
    }
  }, rightText && /*#__PURE__*/_react.default.createElement("div", {
    className: "small-header-text",
    "data-testid": "rightText"
  }, /*#__PURE__*/_react.default.createElement(_HeaderText.HeaderText, {
    headerStyle: _objectSpread({
      fontSize: 13,
      fontWeight: 400,
      lineHeight: '28px',
      marginRight: 10,
      color: '#ffffff'
    }, rightTextStyle),
    variant: "link-text",
    headerText: rightText
  }), " "), rightImage && type !== "Desktop" && /*#__PURE__*/_react.default.createElement("div", {
    className: "right-image d-flex align-items-center p-3",
    "data-testid": "rightImage"
  }, /*#__PURE__*/_react.default.createElement(_Image.Image, {
    url: rightImage,
    imageStyle: rightImageStyle,
    onLeftClick: onRightClick
  })), rightButtonText && rightButtonOnClick && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    "data-testid": "rightButtonText",
    title: rightButtonText,
    variant: "nav-link-button",
    className: "",
    buttonStyle: {
      width: "100%"
    },
    onClick: rightButtonOnClick
  })));
};
var _default = exports.default = CustomHeader;